import { ToastOptions } from 'react-toastify'

import { COMMON_OPTIONS, PLAYER_ID, ToastDispatcher } from './typesAndConstatnts'
import { dispatchOrUpdateToast } from './dispatchOrUpdateToast'
import { CloseButton } from '../ToastContainer/CloseButton'
import './toast-styles.css'

const getOptions = (id?: string, customConfig?: ToastOptions): ToastOptions => ({
  ...COMMON_OPTIONS,
  style: { backgroundColor: '#ffffff' },
  progressClassName: 'progress-bar-player',
  autoClose: false,
  closeOnClick: false,
  draggable: false,
  closeButton: ({ closeToast }) => (
    // @ts-ignore
    <CloseButton
      closeToast={(opts: any) => {
        closeToast(opts)
        pausePlayerInsideToast(id)
      }}
    />
  ),
  ...customConfig,
  toastId: id
})

export const player: ToastDispatcher = ({ content, config }) => {
  const layout = content
  const options = getOptions(PLAYER_ID, config)

  dispatchOrUpdateToast({
    layout,
    options
  })
}

const pausePlayerInsideToast = (toastId?: string) => {
  const toast = document.querySelector(`#${toastId}`)
  const player = toast?.querySelector('audio') as HTMLAudioElement | null | undefined

  if (player) {
    player.pause()
  }
}
